/**
 * Shared date formatters. Falsy input returns '' so callers can supply their
 * own placeholder text (e.g. 'Unknown date') via a guard when needed.
 *
 * Parsing uses UTC for naive API timestamps; display is always local timezone.
 */

import { parseApiDate } from './parseApiDate';

const TIME_PARTS = { hour: '2-digit', minute: '2-digit' };

/** e.g. "Jul 2, 2026, 08:24 AM" (month: 'short') in the client local timezone. */
export function formatDateTime(dateString) {
  const date = parseApiDate(dateString);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...TIME_PARTS,
  });
}

/** e.g. "July 2, 2026, 08:24 AM" (month: 'long') in the client local timezone. */
export function formatDateTimeLong(dateString) {
  const date = parseApiDate(dateString);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...TIME_PARTS,
  });
}

/** e.g. "Jul 2" (no year or time) in the client local timezone. */
export function formatMonthDay(dateString) {
  const date = parseApiDate(dateString);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}

/** e.g. "7/22/2026" using the client locale/timezone. */
export function formatLocalDate(dateString) {
  const date = parseApiDate(dateString);
  if (!date) return '';
  return date.toLocaleDateString();
}

/** e.g. full locale string in the client timezone. */
export function formatLocalDateTime(dateString) {
  const date = parseApiDate(dateString);
  if (!date) return '';
  return date.toLocaleString();
}
